import { render, staticRenderFns } from "./MessageLog.vue?vue&type=template&id=0c50ab10&scoped=true"
import script from "./MessageLog.vue?vue&type=script&lang=js"
export * from "./MessageLog.vue?vue&type=script&lang=js"
import style0 from "./MessageLog.vue?vue&type=style&index=0&id=0c50ab10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c50ab10",
  null
  
)

export default component.exports